<div class="challenge-sections">
  <div
    *ngFor="let section of sections"
    class="challenge-sections--item"
    [class.expanded]="isSectionExpanded(section.id)"
    [id]="section.id"
  >
    <div class="challenge-sections--header" (click)="toggleSection(section.id)">
      <span class="challenge-sections--label">{{ section.label }}</span>
      <div class="challenge-sections--actions">
        <button
          class="challenge-sections--link"
          (click)="scrollToSection(section.id, $event)"
          type="button"
          title="Copy link"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
            <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
          </svg>
        </button>
        <svg
          class="challenge-sections--arrow"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M5 12h14M12 5l7 7-7 7"></path>
        </svg>
      </div>
    </div>
    <div class="challenge-sections--body" *ngIf="isSectionExpanded(section.id)">
      <div class="challenge-sections--content-text">
        <pre>{{ section.content }}</pre>
      </div>
    </div>
  </div>
</div>


